import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import { Tag } from '~/components/Atoms/Tag'

import homeShape from '~/assets/homeShape.svg'
import lock from '~/assets/lock.svg'
import { useCompany } from '~/lib/company'

export function CardBanner() {
  const theme = useTheme()
  const { t } = useTranslation()
  const { data } = useCompany()

  return (
    <Box
      display="flex"
      borderRadius={theme.radius.L}
      padding={`${theme.spacing['6XL']} ${theme.spacing['4XL']}`}
      sx={{
        background: `linear-gradient(90deg, ${theme.palette.gradient.mainLight} 0%, ${theme.palette.gradient.mainDark} 100%)`,
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
      }}
    >
      <Box display="flex" flexDirection="column" gap={theme.spacing['6XL']} width={'100%'}>
        <Tag
          label={data?.name ?? ''}
          typoVariant="h3"
          bgcolor={theme.palette.background['a-hover-inverse']}
          padding={`${theme.spacing.M} ${theme.spacing.L}`}
        />
        <Box display="flex" flexDirection="column">
          <Typography variant="display-bold" color={theme.palette.text.inverse}>
            {t('home:banner.title')}
          </Typography>
          <Typography variant="display-light" color={theme.palette.text.inverse}>
            {t('home:banner.subtitle')}
            <img
              style={{
                height: '98px',
                position: 'absolute',
                bottom: 0,
              }}
              src={lock}
            />
          </Typography>
        </Box>
      </Box>
      <img
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
        }}
        src={homeShape}
      />
    </Box>
  )
}
